import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MdbPopoverDirective, MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { PopoverService } from 'app/core/services/popover.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { ToastService } from 'app/toast/services/toast.service';

let id = 1;

@Component({
  standalone:true,
  selector: 'app-p2p-link-popover',
  templateUrl: './p2p-link-popover.component.html',
  styleUrls: ['./p2p-link-popover.component.scss'],
  imports:[MdbPopoverModule]
})
export class P2pLinkPopoverComponent implements OnInit {

  @ViewChild('popover') popover: MdbPopoverDirective = null;

  @Input() title = 'Link';
  @Input() params = null;

  private _id = id++;
  
  get id() {
    return `P2PLinkPopoverEvent_${this._id}`;
  }

  constructor(
    private popoverService: PopoverService,
    private clipboard: Clipboard,
    private toastService: ToastService,

  ) { }

  ngOnInit(): void {
  }

  openLink() {
    window.open(this.params.url, '_blank');
  }

  copyLink() {
    this.clipboard.copy(this.params.url);
    this.toastService.show('success', 'URL copied to clipboard', {delay: 1500})
  }

  downloadQrCode() {
    const hideLink = true
    window['orgMain'].setupQRDownload(this.params.type, '', this.params.url, this.params.fileName, null, hideLink)
  }

  onPopoverShown(): void {
    this.popoverService.list[this.id] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }

}
